/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MeasurementUnit = {
    /**
    * Millimetres
    */
    NUMBER_1: 1,
    /**
    * Percentage
    */
    NUMBER_2: 2,
    /**
    * Unknown
    */
    NUMBER_MINUS_1: -1
} as const;
export type MeasurementUnit = typeof MeasurementUnit[keyof typeof MeasurementUnit];


export function instanceOfMeasurementUnit(value: any): boolean {
    for (const key in MeasurementUnit) {
        if (Object.prototype.hasOwnProperty.call(MeasurementUnit, key)) {
            if (MeasurementUnit[key as keyof typeof MeasurementUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MeasurementUnitFromJSON(json: any): MeasurementUnit {
    return MeasurementUnitFromJSONTyped(json, false);
}

export function MeasurementUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasurementUnit {
    return json as MeasurementUnit;
}

export function MeasurementUnitToJSON(value?: MeasurementUnit | null): any {
    return value as any;
}

export function MeasurementUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): MeasurementUnit {
    return value as MeasurementUnit;
}

